import React, { useEffect } from 'react';
import qs from 'qs';
import { useSelector, useDispatch } from 'react-redux';
import { setInitialised, setData, setError, setLoadedConfiguration } from 'src/redux/app/actions';
import Loader from 'components/_utility/Loader/Loader';
import request, { getApiEntrypoint, getHostname } from 'helpers/request';
import { initialisedSelector, getLoadedConfiguration } from 'src/redux/app/selectors';

const Init = ({ children }) => {
  const initialised = useSelector(initialisedSelector);
  const loadedConfiguration = useSelector(getLoadedConfiguration);
  const dispatch = useDispatch();
  const { bikeId, configurationId, colourId, provinceid } = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const queryParams = new URLSearchParams();
        if (colourId && !loadedConfiguration) {
          queryParams.append('colourId', colourId);
        }
        if (provinceid) {
          queryParams.append('provinceid', provinceid);
        }

        const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';
        const apiUrl = `${getHostname()}${getApiEntrypoint()}/${bikeId}${queryString}`;

        const contentRes = await request(apiUrl, {}, true);

        dispatch(setData(contentRes.data));

        if (configurationId) {
          const { data: configuration } = await request(`/api/configurator/garage/${configurationId}`);

          dispatch(setLoadedConfiguration(configuration));
        }

        dispatch(setInitialised());
      } catch (ex) {
        console.error(ex);
        dispatch(setError(ex));
      }
    };

    fetchData();
  }, []);

  if (!initialised) {
    return <Loader />;
  }

  return children;
};

export default Init;
